(function () {
  'use strict';
  var configNode = document.getElementById('cchw-ux-preview-config');
  if (!configNode) return;
  var config = JSON.parse(configNode.textContent);
  var enabled = config.features;
  var mobile = window.matchMedia('(max-width: 749px)');

  function mobileProduct() {
    if (document.querySelector('.cchw-crate-layout')) return;
    if (!enabled['mobile-product']) return;
    var title = document.querySelector('.product-page__product-title');
    var price = document.querySelector('.product-page__price-row');
    var photo = document.querySelector('.product-page__image-playlist-container .product__photo');
    if (!title || !price || !photo) return;
    var titleMarker = document.createComment('Product title original position');
    var priceMarker = document.createComment('Product price original position');
    title.before(titleMarker);
    price.before(priceMarker);
    var summary = document.createElement('div');
    summary.className = 'cchw-ux-product-summary';
    photo.before(summary);
    function arrange() {
      if (mobile.matches) {
        summary.append(title, price);
      } else {
        titleMarker.after(title);
        priceMarker.after(price);
      }
    }
    arrange();
    mobile.addEventListener('change', arrange);
  }

  function genres(scope) {
    if (!enabled['genre-search']) return;
    scope.querySelectorAll('.cchw-filter-group').forEach(function (group, index) {
      var heading = group.querySelector('.cchw-filter-label');
      var chips = Array.from(group.querySelectorAll('label.cchw-filter-chip'));
      if (!heading || !/genre|style/i.test(heading.textContent) || !chips.length || group.querySelector('.cchw-ux-genre-search')) return;
      heading.textContent = config.text.genre;
      var label = document.createElement('label');
      label.className = 'cchw-ux-genre-search';
      var caption = document.createElement('span');
      caption.textContent = config.text.findGenre;
      var input = document.createElement('input');
      input.type = 'search';
      input.placeholder = config.text.findGenre;
      input.autocomplete = 'off';
      label.append(caption, input);
      heading.after(label);
      var empty = document.createElement('p');
      empty.className = 'cchw-ux-genre-empty';
      empty.textContent = config.text.noGenres;
      empty.hidden = true;
      empty.setAttribute('role', 'status');
      group.append(empty);
      function filter() {
        var query = input.value.trim().toLocaleLowerCase();
        var visible = 0;
        chips.forEach(function (chip) {
          var checkbox = chip.querySelector('input');
          var matches = chip.textContent.toLocaleLowerCase().includes(query);
          chip.hidden = !matches && !checkbox.checked;
          if (matches) visible++;
        });
        empty.hidden = visible > 0;
      }
      input.addEventListener('input', filter);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.preventDefault();
      });
    });
  }

  function emptyCart() {
    if (!enabled['empty-cart']) return;
    var body = document.querySelector('.template-cart .cart__body');
    if (!body || body.querySelector('form')) return;
    var browse = body.querySelector('a.btn');
    if (!browse) return;
    browse.textContent = config.text.browseNew;
    browse.href = '/collections/new-vinyl';
    browse.classList.add('cchw-ux-cart-primary');
    var secondary = document.createElement('a');
    secondary.href = '/collections/bestselling-vinyl-2';
    secondary.textContent = config.text.bestsellers;
    secondary.className = 'cchw-ux-cart-secondary';
    browse.after(secondary);
  }

  function controlTouch(selector, prefix) {
    var pressed = null;
    function release() {
      if (pressed) pressed.classList.remove(prefix + '-pressed');
      pressed = null;
    }
    document.addEventListener('pointerdown', function (event) {
      release();
      var button = event.target.closest(selector);
      if (!button) return;
      var touch = event.pointerType === 'touch' || event.pointerType === 'pen';
      button.classList.toggle(prefix + '-touch', touch);
      if (touch) {
        pressed = button;
        button.classList.add(prefix + '-pressed');
      }
    }, {passive: true, capture: true});
    document.addEventListener('pointerup', release, {passive: true, capture: true});
    document.addEventListener('pointercancel', release, {passive: true, capture: true});
    window.addEventListener('blur', release);
  }

  function init() {
    controlTouch('.product-grid-item .cchw-card-actions :is(a.player-addplaylist, button.addToCart:not(.cchw-notify-me), button.cchw-notify-me)', 'cchw-card');
    controlTouch('.template-product .product-details-playlist :is(.play-all-button, .player-playtrack-button)', 'cchw-playlist');
    mobileProduct();
    genres(document);
    emptyCart();
    document.addEventListener('shopify:section:load', function (event) {
      genres(event.target);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
